import { MODE } from "../../src/Renderer/PointsMaterial";

function isInHierarchy(elt, hierarchyNode) {
  if (elt.name.length > hierarchyNode.length) {
    return elt.name.startsWith(hierarchyNode);
  } else if (elt.name.length < hierarchyNode.length) {
    return hierarchyNode.startsWith(elt.name);
  } else {
    return hierarchyNode === elt.name;
  }
}

export default {
  initTools: function initTools(view, layer, datUi) {
    var update = function () {
      return view.notifyChange(layer);
    };

    layer.debugUI = datUi.addFolder("".concat(layer.id));
    layer.debugUI.add(layer, 'visible').name('Visible').onChange(update);
    layer.debugUI.add(layer, 'sseThreshold').name('SSE threshold').onChange(update);
    layer.debugUI.add(layer, 'octreeDepthLimit', -1, 20).name('Depth limit').onChange(update);
    layer.debugUI.add(layer, 'pointBudget', 1, 15000000).name('Max point count').onChange(update);
    layer.debugUI.add(layer.object3d.position, 'z', -50, 50).name('Z translation').onChange(function () {
      layer.object3d.updateMatrixWorld();
      view.notifyChange(layer);
    });
    layer.dbgEnableStickyNode = false;
    layer.dbgStickyNode = '';
    layer.dbgDisplayChildren = true;
    layer.dbgDisplayParents = true;
    layer.dbgDisplaybbox = false;
    var styleUI = layer.debugUI.addFolder('Styling');

    if (layer.material.mode != undefined) {
      styleUI.add(layer.material, 'mode', MODE).name('Display mode').onChange(update);
    }

    styleUI.add(layer, 'opacity', 0, 1).name('Layer Opacity').onChange(update);
    styleUI.add(layer, 'pointSize', 0, 15).name('Point Size').onChange(update);
    styleUI.add(layer, 'dbgDisplaybbox').name('Display Bounding Boxes').onChange(update);

    if (layer.material.picking != undefined) {
      styleUI.add(layer.material, 'picking').name('Display picking id').onChange(update);
    } // UI


    var sticky = layer.debugUI.addFolder('Sticky');
    sticky.add(layer, 'dbgEnableStickyNode').name('Enable sticky node').onChange(update);
    sticky.add(layer, 'dbgStickyNode').name('Sticky node name').onChange(update);
    sticky.add(layer, 'dbgDisplayChildren').name('Display children of sticky node').onChange(update);
    sticky.add(layer, 'dbgDisplayParents').name('Display parents of sticky node').onChange(update);
    view.addFrameRequester('after_layer_update', function () {
      if (layer.bboxes) {
        layer.bboxes.visible = layer.dbgDisplaybbox;
      }

      if (layer.dbgEnableStickyNode) {
        layer.displayedCount = 0;
        var stickies = layer.dbgStickyNode.split(',');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = layer.group.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var pts = _step.value;
            pts.material.visible = false;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = stickies[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var name = _step2.value;

                if (pts.userData.metadata.name == name) {
                  pts.material.visible = true;
                } else if (!isInHierarchy(pts.userData.metadata, name)) {
                  continue;
                } else if (pts.userData.metadata.name.length < name.length) {
                  pts.material.visible = layer.dbgDisplayParents;
                  break;
                } else {
                  pts.material.visible = layer.dbgDisplayChildren;
                }

                if (pts.material.visible) {
                  break;
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                  _iterator2["return"]();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            if (pts.material.visible) {
              layer.displayedCount += pts.geometry.attributes.position.count;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = layer.group.children[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _pts = _step3.value;

          if (_pts.boxHelper) {
            _pts.boxHelper.material.visible = layer.dbgDisplaybbox && _pts.visible && _pts.material.visible;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
            _iterator3["return"]();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    });
  }
};